<template>
  <base-row
    v-bind="$props"
    :selectable="true"
  >
    <td>
      {{ item.package.product_name }}<br />
      <small>
        {{ item.package.details.batch_num }} | {{ item.package.details.lot_num }} | {{ item.package.details.tag_num }}
      </small>
    </td>

    <td>
      {{ item.origin.name || 'NA' }}
    </td>

    <td>
      {{ item.destination.name || 'NA' }}
    </td>

    <td>
      {{ item.orders }}
    </td>

    <td>
      {{ item.transferred }}
    </td>

    <td>
      {{ item.demand }}
    </td>

    <td>
      {{ item.available }}
    </td>
  </base-row>
</template>

<script>
import { Link } from '@inertiajs/vue3'
import TableRow from '@/Components/Table/TableRow'
import RowProps from '@/Components/Table/Mixins/RowProps'
import BasicBadge from '@/Components/Badges/BasicBadge.vue'
import _date from '@/Filters/Date'
import _dollars from '@/Filters/Dollars'
import _time from '@/Filters/Time'
import moment from 'moment'

export default {
  components: {
    'base-row': TableRow,
    Link,
    BasicBadge
  },

  mixins: [RowProps],

  methods: {}
}
</script>
